import { render } from "./DeleteClientModal.vue?vue&type=template&id=43d04bc9&ts=true"
import script from "./DeleteClientModal.vue?vue&type=script&lang=ts"
export * from "./DeleteClientModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__